module.exports = __webpack_public_path__ + "img/3.c9446800.jpg";